import {WPApi} from "../common/wp-api";
import "../common/jquery-functions";
import * as scrollLock from "../common/scroll-lock";
import {onClickOutside} from "../common/utils";

const api = new WPApi();

const currentState = location.pathname + location.search;
let isFromHistory = false;


jQuery(document).ready(($) => {


    if(!$('body').hasClass('single-post')){
        $('body').append('<div class="vod-player-wrapper"></div>');
    }
    $(document).on('click', '.close', async function (e) {
        togglePlayer(false);
    });

    $(document).keyup(function (e) {
        // esc
        if (e.keyCode === 27) {
            togglePlayer(false);
        }
    });

    // onClickOutside('.vod-player-content', function () {
    //     togglePlayer(false);
    // });

    $(document).on('click', '.post-link:not(.vod-related-video)', async function (e) {
        e.preventDefault();

        const path = $(this).attr('href');

        const postId = $(this).data('id');

        togglePlayer(true);
        let $playerWrapper = $('.vod-player-wrapper');

        $playerWrapper.loader(true);

        const playerHtml = await loadPlayer(postId);
        $playerWrapper.loader(false);
        $playerWrapper.html(playerHtml);

        lazyLoader.update();

        window.history.pushState({}, '', path);

        return false;
    });

});


window.onpopstate = function (event) {
    togglePlayer(false);
    return true;
};

async function loadPlayer(postId) {

    return await api.get(`sport1/v1/content/video/${postId}/template`);

}

let playerShown = false;
let isShowingPlayer = false;
let original=$('#walla-iframe-video').attr('src');
function togglePlayer(show) {

    let $playerWrapper = $('.vod-player-wrapper');
    isFromHistory = true;
    if (show) {
        if (playerShown) {
            return;
        }
        isShowingPlayer = true;
        playerShown = true;
        $('.vod-related-video').first().addClass('next');
        $playerWrapper.addClass('slide-up');
        $('#walla-iframe-video').attr('src',original);
        $('.vod-related-video.playing').removeClass('playing');
        scrollLock.default(true, $playerWrapper);
        setTimeout(() => {
            isShowingPlayer = false;
        }, 2000);
    } else {
        if (isShowingPlayer) {
          //  $('#brightcove-iframe-video').attr('src','original');
            return;
        }

        if($('body').hasClass('single-post')) {
            $('#walla-iframe-video').attr('src',original);
        }

        setTimeout(() => {
            $playerWrapper.html('');
        }, 250);

        $playerWrapper.removeClass('slide-up');
        playerShown = false;

         scrollLock.default(false, $playerWrapper);
         window.history.replaceState({}, '', currentState)
    }

}

